import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../../../libs/common-service/utility-service';
import { format } from 'date-fns';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StatementReportService } from './statement-report-service';
import { ToastrService } from 'ngx-toastr';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import * as lodash from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDownloadPdfExcelComponent } from '@pg-app/common/confirm-download-pdf-excel/confirm-download-pdf-excel.component';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';
import { CsvElementsToIncludeClientStatementComponent } from './csv-elements-to-include-client-statement/csv-elements-to-include-client-statement.component';
import { ClientProfileService } from '../services/client-profile.service';
@Component({
  selector: 'np-statement-report',
  templateUrl: './statement-report.component.html',
  styleUrls: ['./statement-report.component.scss']
})
export class StatementReportComponent implements OnInit {
  today = new Date();
  searchForm: FormGroup;

  clientInformation: any;

  public rows = [];
  public columns = [];

  public rowsOutstanding = [];
  public columnsOutstanding = [];

  public rowsBalanceSummary = [];
  public columnsBalanceSummary = [];

  public rowsBalanceDetail = [];
  public columnsBalanceDetail = [];

  public rowsPendingTransactions = [];

  class = '';
  balanceDetails: any[] = [];

  allColumns = [
    {
      title: 'Trade reference',
      name: 'tradeNumber'
    },
    {
      title: 'Associated Trades',
      name: 'associatedTrades'
    },
    {
      title: 'Creation date',
      name: 'creationDate'
    },
    {
      title: 'Trade type',
      name: 'tradeType'
    },
    {
      title: 'Open Date (if ODF)',
      name: 'openDate'
    },
    {
      title: 'Sell CCY',
      name: 'sellCurrencyCode'
    },
    {
      title: 'Original Sell Notional (If ODF)',
      name: 'originalSellNotional'
    },
    {
      title: 'Sell Notional',
      name: 'sellNotional'
    },
    {
      title: 'Rate',
      name: 'rate'
    },
    {
      title: 'Buy CCY',
      name: 'buyCurrencyCode'
    },
    {
      title: 'Original Buy Notional (If ODF)',
      name: 'originalBuyNotional'
    },
    {
      title: 'Buy notional',
      name: 'buyNotional'
    },
    {
      title: 'Value date',
      name: 'valueDate'
    }
  ];

  visibleColumns = [];
  hiddenColumns = [];

  todo = [];
  done = [];
  showOrderColumn = false;

  allColumnTrades = [
    {
      title: 'Trade reference',
      name: 'tradeNumber',
      width: '130px'
    },
    {
      title: 'Associated Trades',
      name: 'associatedTrades',
      class: 'asociated-trade',
      width: '150px'
    },
    {
      title: 'Creation date',
      name: 'creationDate',
      type: TableCellTypes.Date,

      width: '130px'
    },
    {
      title: 'Trade type',
      name: 'tradeType',
      width: '215px'
    },
    {
      title: 'Open Date (if ODF)',
      name: 'openDate',
      type: TableCellTypes.Date,

      width: '150px'
    },
    {
      title: 'Sell CCY',
      name: 'sellCurrencyCode',
      width: '100px'
    },
    {
      title: 'Original Sell Notional (If ODF)',
      name: 'originalSellNotional',
      type: TableCellTypes.Number,
      class: 'text-right odf-cell',
      width: '220px'
    },
    {
      title: 'Sell Notional',
      name: 'sellNotional',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Rate',
      name: 'rate',
      type: TableCellTypes.Rate,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Buy CCY',
      name: 'buyCurrencyCode',
      width: '100px'
    },
    {
      title: 'Original Buy Notional (If ODF)',
      name: 'originalBuyNotional',
      type: TableCellTypes.Number,
      class: 'text-right odf-buy-cell',
      width: '220px'
    },
    {
      title: 'Buy notional',
      name: 'buyNotional',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '150px'
    },
    {
      title: 'Value date',
      name: 'valueDate',
      type: TableCellTypes.Date,
      width: '130px'
    }
  ];

  isLoading = true;
  showConsolidatedDownload = false;

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  constructor(
    private statementReportService: StatementReportService,
    private utilityService: UtilityService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private clientService: ClientProfileService,
  ) { }

  ngOnInit() {
    this.searchForm = this.fb.group({
      fromDate: [new Date(this.today.getFullYear(), this.today.getMonth(), 1), Validators.required],
      toDate: [new Date(), Validators.required]
    });

    this.columnsBalanceDetail = [
      {
        title: 'Date',
        name: TableCellTypes.Date,
        width: '100px'
      },
      {
        title: 'Description',
        name: 'description',
        width: '230px'
      },
      {
        title: 'Reference',
        name: 'reference',
        width: '230px'
      },
      {
        title: 'Amount',
        name: 'amount',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '150px'
      }
    ];

    this.getInfomationClient(() => {
      this.getColumns();
    });
    this.clientService.singleEmailAccounts$.subscribe(res => {
      this.showConsolidatedDownload = res;
    })
  }

  getInfomationClient(callback) {
    this.statementReportService.getInformationClient().subscribe(data => {
      this.clientInformation = data;
      callback();
    });
  }

  getColumns() {
    const params = {
      leadId: null,
      report: 1,
      columns: null
    };
    this.statementReportService.getColumns(params).subscribe(data => {
      if (data && data.length > 0) {
        const columns = data.sort((previous, next) => {
          return previous.order > next.order ? 1 : -1;
        });

        this.columns = [];
        this.columnsOutstanding = [];
        columns.forEach(item => {

          const column = this.allColumns.find(p => p.name === item.columnName);
          this.visibleColumns.push(column.title);

          const columnTable = this.allColumnTrades.find(p => p.title === column.title);
          this.columns.push(columnTable);
          this.columnsOutstanding.push(columnTable);
        });
        this.hiddenColumns = this.allColumns.filter(column => this.visibleColumns.indexOf(column.title) < 0).map(d => d.title);
      } else {
        this.visibleColumns = this.allColumns.map(d => d.title);
        this.hiddenColumns = [];
        this.columns = this.allColumnTrades;
        this.columnsOutstanding = this.allColumnTrades;
      }

      this.getHistoricTrades();
      this.getOutStandingTrades();

      this.getBalance();
    });
  }

  updateColumns() {
    this.isLoading = true;
    const columns = [];
    let newColumns = [];
    let newColumnsOutstanding = [];
    this.visibleColumns.forEach(column => {
      const item = this.allColumns.find(p => p.title === column);
      const columnTable = this.allColumnTrades.find(p => p.title === item.title);
      newColumns.push(columnTable);
      newColumnsOutstanding.push(columnTable);
      columns.push({
        columnName: item.name,
        order: this.visibleColumns.indexOf(column)
      });
    });
    this.columns = newColumns;
    this.columnsOutstanding = newColumnsOutstanding;
    const params = {
      fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
      toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD'),
      columns: columns,
      report: 1,
      leadId: null
    };
    this.statementReportService.updateColumns(params).subscribe(() => this.isLoading = false);
  }

  orderColumnOption() {
    this.showOrderColumn = !this.showOrderColumn;
  }

  searchReport() {
    this.isLoading = true;
    if (this.searchForm.valid) {
      if (new Date(this.searchForm.get('fromDate').value) > new Date(this.searchForm.get('toDate').value)) {
        this.toastr.error('From date should not be greater than To date. Please try again!');
        return;
      }

      if (this.visibleColumns.length === 0) {
        this.toastr.error('Please select columns for table!');
        this.showOrderColumn = true;
        return;
      }
      this.showOrderColumn = false;
      this.columns = [];
      this.columnsOutstanding = [];
      this.visibleColumns.forEach(item => {
        const column = this.allColumnTrades.find(p => p.title === item);
        this.columns.push(column);
        this.columnsOutstanding.push(column);
      });

      this.updateColumns();

      this.getHistoricTrades();
      this.getOutStandingTrades();

      this.getBalance();
    }
  }

  downloadStatementPDF(consolidatedMode) {
    const dialogRef = this.dialog.open(ConfirmDownloadPdfExcelComponent, {
      data: {
        title: 'Do you want to download PDF, Excel or CSV?',
        radioBtn1: 'PDF',
        radioBtn2: 'Excel',
        enableCsvOption: true,
        consolidatedMode: consolidatedMode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      const columnsReport = [];
      this.visibleColumns.forEach(column => {
        const item = this.allColumns.find(p => p.title === column);
        columnsReport.push({
          columnName: item.name,
          order: this.visibleColumns.indexOf(column)
        });
      });

      if (result === '0') {
        const params = {
          fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
          toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD'),
          columns: columnsReport,
          partnerName: this.clientInformation.leadName,
          partnerCode: this.clientInformation.leadCode,
          partnerAddress: this.clientInformation.leadAddress,
          includeUnverifiedTrade: false,
          consolidatedMode: consolidatedMode
        };
        this.statementReportService.exportClient(params).subscribe(data => {
          const fileName = `Statement_Report_${format(this.searchForm.get('fromDate').value, 'DDMMYYYY')}_${format(
            this.searchForm.get('toDate').value,
            'DDMMYYYY'
          )}.pdf`;
          this.utilityService.downloadFile(data, fileName, DownloadFileTypeEnum.PDF);
        });
      } else if (result === '1') {
        const params = {
          fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
          toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD'),
          columns: columnsReport,
          leadId: null,
          includeUnverifiedTrade: false,
          consolidatedMode: consolidatedMode
        };

        this.statementReportService.exportClientReportExcel(params).subscribe(data => {
          const fileName = `Statement_Report_${format(this.searchForm.get('fromDate').value, 'DDMMYYYY')}_${format(
            this.searchForm.get('toDate').value,
            'DDMMYYYY'
          )}.xlsx`;
          this.utilityService.downloadFile(
            data,
            fileName,
            DownloadFileTypeEnum.Excel
          );
        });
      } else if (result === '2') {
        const csvElementsToIncludeDialog = this.dialog.open(CsvElementsToIncludeClientStatementComponent, {});
        csvElementsToIncludeDialog.afterClosed().subscribe(csvElementsToIncludeResults => {
          if (csvElementsToIncludeResults) {
            const params = {
              fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
              toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD'),
              columns: columnsReport,
              leadId: null,
              includeUnverifiedTrade: false,
              csvElementsToInclude: csvElementsToIncludeResults,
              consolidatedMode: consolidatedMode
            };

            this.statementReportService.exportClientReportCsv(params).subscribe(data => {
              const fileName = `Statement_Report_${format(this.searchForm.get('fromDate').value, 'DDMMYYYY')}_${format(
                this.searchForm.get('toDate').value,
                'DDMMYYYY'
              )}.zip`;
              this.utilityService.downloadFile(
                data,
                fileName,
                DownloadFileTypeEnum.Zip
              );
              this.updateColumns();
            });
          } else if (!consolidatedMode) {
            this.downloadStatementPDF(consolidatedMode);
          }
        });
      }

      if (result && result !== '2') {
        this.updateColumns();
      }
    });
  }

  togglePicker(picker) {
    picker.opened ? picker.close() : picker.open();
  }

  getBalance() {
    const params = {
      fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
      toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD'),
      includeUnverifiedTrade: false,
    };

    // this.rowsBalanceSummary = [];
    this.balanceDetails = [];

    const columns = [
      {
        title: 'CCY',
        name: 'ccy',
        class: 'currency',
        width: '100px'
      },
      {
        title: 'Available Funds',
        name: 'availableFunds',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '230px'
      },
      {
        title: 'FWD Deposits Held',
        name: 'fwdDespositsHeld',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '230px'
      },
      {
        title: 'Margin Held',
        name: 'marginHeld',
        type: TableCellTypes.Number,
        class: 'text-right',
        width: '150px'
      }
    ];

    const pendingPaymentBalance = {
      title: 'Pending Payment Balance',
      name: 'totalPendingBalance',
      type: TableCellTypes.Number,
      class: 'text-right',
      width: '230px'
    };

    this.columnsBalanceSummary = new Date(this.searchForm.get('toDate').value).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
      ? columns : [].concat(columns[0], columns[1], pendingPaymentBalance, columns[2], columns[3]);

    this.statementReportService.getStatementBalance(params).subscribe(res => {
      const data = res || [];
      this.rowsBalanceSummary = res || [];
      this.balanceDetails = [];
      this.isLoading = false;
    });
  }

  getHistoricTrades() {
    const params = {
      fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
      toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD')
    };

    let historicTrades = [];

    this.statementReportService.getStatementTradeSettled(params).subscribe(data => {
      data.forEach(item => {
        item.clientStatementTrades.forEach(trade => {
          trade.class = 'normal-trade';
          historicTrades = historicTrades.concat(trade);

          if (this.visibleColumns.indexOf('Associated Trades') !== -1 && trade.associatedTrades.length > 0) {
            const drawdowns = lodash.cloneDeep(trade.associatedTrades);
            trade.associatedTrades = 'View';
            drawdowns.forEach(drawdown => {
              drawdown.class = `drawdown ${trade.tradeNumber} d-none`;
            });
            historicTrades = historicTrades.concat(drawdowns);
          }
        });

        if (this.visibleColumns.indexOf('Sell Notional') !== -1 || this.visibleColumns.indexOf('Buy Notional') !== -1) {
          historicTrades = historicTrades.concat({
            originalSellNotional: 'Total:',
            sellNotional: item.totalSell,
            buyNotional: item.totalBuy,
            class: 'total-row'
          });
        } else {
          historicTrades = historicTrades.concat({
            originalSellNotional: '',
            sellNotional: '',
            buyNotional: '',
            class: 'total-row'
          });
        }
      });
      this.rows = historicTrades;
    });
  }

  getOutStandingTrades() {
    const params = {
      fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
      toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD')
    };

    let outStandingTrades = [];

    this.statementReportService.getStatementTradeOpen(params).subscribe(data => {
      data.forEach(item => {
        item.clientStatementTrades.forEach(trade => {
          outStandingTrades = outStandingTrades.concat(trade);

          if (this.visibleColumns.indexOf('Associated Trades') !== -1 && trade.associatedTrades.length > 0) {
            const drawdowns = lodash.cloneDeep(trade.associatedTrades);
            trade.associatedTrades = 'View';
            drawdowns.forEach(drawdown => {
              drawdown.class = `drawdown ${trade.tradeNumber} d-none`;
            });
            outStandingTrades = outStandingTrades.concat(drawdowns);
          }
        });

        if (this.visibleColumns.indexOf('Sell Notional') !== -1 || this.visibleColumns.indexOf('Buy Notional') !== -1) {
          outStandingTrades = outStandingTrades.concat({
            originalSellNotional: 'Total:',
            sellNotional: item.totalSell,
            buyNotional: item.totalBuy,
            class: 'total-row'
          });
        } else {
          outStandingTrades = outStandingTrades.concat({
            originalSellNotional: '',
            sellNotional: '',
            buyNotional: '',
            class: 'total-row'
          });
        }
      });
      this.rowsOutstanding = outStandingTrades;
    });
  }

  onCellClick(data) {
    if (data.column !== 'associatedTrades' || !data.row.associatedTrades) {
      return;
    }
    const classColors = `${data.row.tradeNumber}`;
    const drawdowns = Array.from(document.getElementsByClassName(classColors));
    if (drawdowns.length > 0) {
      const hiddenDrawdown = drawdowns.find(item => item.classList.contains('d-none'));
      drawdowns.forEach(drawdown => {
        if (hiddenDrawdown) {
          drawdown.classList.remove('d-none');
        } else {
          drawdown.classList.add('d-none');
        }
      });
    }
  }

  onCellClickBalanceSummary(data) {
    if (data.column !== 'ccy') {
      return;
    }

    const currentCurrency = data.row.ccy;
    const clickedBalance = this.balanceDetails.find(s => s.ccy == currentCurrency);
    if (clickedBalance) {
      clickedBalance.isHidden = !clickedBalance.isHidden;
      return;
    }

    const params = {
      fromDate: format(this.searchForm.get('fromDate').value, 'YYYYMMDD'),
      toDate: format(this.searchForm.get('toDate').value, 'YYYYMMDD'),
      includeUnverifiedTrade: false,
      currencyCode: currentCurrency
    };

    this.statementReportService.getStatementBreakdownForCurrency(params).subscribe(res => {
      let balanceDetail: any = {
        ccy: currentCurrency,
        isHidden: false,
        balanceBreakdown: [],
        pendingTransactions: [],
        outstandingTransactions: []
      };
      balanceDetail.balanceBreakdown = [
        {
          date: '',
          description: 'Opening balance',
          reference: '',
          amount: data.row.openingBalance
        }
      ].concat(res);

      balanceDetail.balanceBreakdown = balanceDetail.balanceBreakdown.concat({
        date: '',
        description: 'Closing balance',
        reference: '',
        amount: data.row.closingBalance,
      });
      balanceDetail.balanceBreakdown = balanceDetail.balanceBreakdown.concat({
        date: '',
        description: 'Total Pending',
        reference: '',
        amount: data.row.totalPendingBalance
      });

      balanceDetail.pendingTransactions = balanceDetail.balanceBreakdown.filter(t => t.isPendingPayment || t.description === 'Total Pending');
      balanceDetail.outstandingTransactions = balanceDetail.balanceBreakdown.filter(t => t.description !== 'Total Pending' && (t.isPendingPayment === undefined || Boolean(t.isPendingPayment) === false));
      this.balanceDetails = [...this.balanceDetails].concat(balanceDetail);
    })
  }
}
